import { tribeMapComponent, prefetchTribeItems } from "./components/tribeMap.js";

prefetchTribeItems();

const registerTribeMapComponent = () => {
  if (!window.Alpine) {
    return false;
  }

  window.Alpine.data("tribeMapComponent", tribeMapComponent);
  return true;
};

const isTribeMapInitialized = (element) => {
  return typeof element._x_dataStack?.[0]?.radiusMiles !== "undefined";
};

const initTribeMapTrees = () => {
  if (!window.Alpine?.initTree) {
    return;
  }

  document.querySelectorAll('[x-data*="tribeMapComponent"]').forEach((element) => {
    if (isTribeMapInitialized(element)) {
      return;
    }

    if (element._x_dataStack?.length && window.Alpine.destroyTree) {
      window.Alpine.destroyTree(element);
    }

    window.Alpine.initTree(element);
  });
};

const isAlpineStarted = () => {
  return Boolean(
    document.body?._x_dataStack?.length ||
      document.querySelector("header[x-data]")?._x_dataStack?.length
  );
};

document.addEventListener("alpine:init", registerTribeMapComponent);

if (registerTribeMapComponent() && isAlpineStarted()) {
  initTribeMapTrees();
}
